<template>
    <div :class="'col-md-'+ col">
        <a :href="link">
            <div :class="'card card-stats ' + color" style="min-height: 100px;">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <span class="text-white">{{ name }}</span>

                            <div v-if="actions" class="dropdown" style="position:absolute; right: 5px; top: 0">
                                <i data-toggle="dropdown" class="now-ui-icons loader_gear text-white"></i>
                                <div class="dropdown-menu dropdown-menu-right" x-placement="top-end"
                                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-122px, -60px, 0px);">
                                    <slot name="dropdown-item"></slot>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <h2 class="font-weight-bold text-white mb-0">
                                {{ value }}
                            </h2>
                        </div>
                    </div>
                    <p class="mt-3 mb-0 text-sm cursor-default"><span
                        class="text-white">{{ label }}</span> <span
                        class="el-tooltip text-white font-weight-bold float-right"
                        aria-describedby="el-tooltip-152" tabindex="0"> {{
                            total && value ? `${value} / ${total}` : ''
                        }}</span>
                    </p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";

export default {
    name: "SiteCardComponent",
    props: {
        col: {
            type: String,
            default: '3'
        },
        name: {
            type: String,
            default: ''
        },
        total: {
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: 'bg-gradient-info'
        },
        link: {
            type: String,
            default: '#'
        },
        actions: {
            type: Boolean,
            default: false
        },
        filter: {
            type: String,
            default: 'ID'
        },
        month: {
            default: (new Date()).getMonth() + 1
        },
        year: {
            default: (new Date()).getFullYear()
        },
        otherParams: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            value: 0
        }
    },
    watch: {
        month(val) {
            this.getTotal()
        },
        year(val) {
            this.getTotal()
        }
    },
    mounted() {
        this.getTotal()
    },
    methods: {
        getTotal() {
            this.$loading(true);
            let app = this;
            let params = {
                "filter": this.filter,
                "month": this.month || '',
                "year": this.year,
            }
            if (Object.values(this.otherParams).length > 0) {
                Object.entries(this.otherParams).forEach((el) => {
                    if (Array.isArray(el[1])) {
                        el[1].forEach((o, i) => {
                            params[`${el[0]}[${i}]`] = o;
                        })
                    } else {
                        params[el[0]] = params[el[1]]
                    }
                });
            }

            var strParams = "";
            for (var key in params) {
                if (strParams != "") {
                    strParams += "&";
                }
                strParams += key + "=" + params[key];
            }


            axios.get(`${URL_BASE}/sites/inspection-frequency/dashboard?${strParams}`)
                .then((response) => {
                    this.$loading(false);
                    app.value = response.data.total
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        }
    }
}
</script>

<style scoped>

</style>
